import { useState } from "react";
import { RefObject } from "react";
import RecipientButton from "./recipientButton/RecipientButton";
import AmountButton from "./amountButton/AmountButton";
import HashTagButton from "./hashtagButton/HashTagButton";
import PostSectionContainerStyles from "./PostSectionContainer.module.css";
import { MentionInputHandle } from "./mentionInput/MentionInput";

type ActiveDropdown = "recipient" | "amount" | "hashtag" | null;

type PostSectionHeaderProps = {
  mentionInputRef: RefObject<MentionInputHandle>;
};

const PostSectionHeader = ({ mentionInputRef }: PostSectionHeaderProps) => {
  const [activeDropdown, setActiveDropdown] = useState<ActiveDropdown>(null);

  const toggleDropdown = (dropdown: ActiveDropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  return (
    <div className={PostSectionContainerStyles.postSectionHeaderBlk}>
      <div className={PostSectionContainerStyles.flexBoxBlk}>
        <RecipientButton
          isOpen={activeDropdown === "recipient"}
          toggleDropdown={() => toggleDropdown("recipient")}
          mentionInputRef={mentionInputRef}
        />
        <AmountButton
          isOpen={activeDropdown === "amount"}
          toggleDropdown={() => toggleDropdown("amount")}
          mentionInputRef={mentionInputRef}
        />
        <HashTagButton
          isOpen={activeDropdown === "hashtag"}
          toggleDropdown={() => toggleDropdown("hashtag")}
          mentionInputRef={mentionInputRef}
        />
      </div>
    </div>
  );
};

export default PostSectionHeader;
